/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Userdropdown_Credits1Inputs */

const zh_userdropdown_credits1 = /** @type {(inputs: Userdropdown_Credits1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`积分`)
};

const en_userdropdown_credits1 = /** @type {(inputs: Userdropdown_Credits1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Credits`)
};

const es_userdropdown_credits1 = /** @type {(inputs: Userdropdown_Credits1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créditos`)
};

/**
* | output |
* | --- |
* | "Credits" |
*
* @param {Userdropdown_Credits1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const userdropdown_credits1 = /** @type {((inputs?: Userdropdown_Credits1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Userdropdown_Credits1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_userdropdown_credits1(inputs)
	if (locale === "en") return en_userdropdown_credits1(inputs)
	return es_userdropdown_credits1(inputs)
});
export { userdropdown_credits1 as "userDropdown_credits" }